
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-baskets-on-sale",
      function () {
        return require("private-next-pages/gift-baskets-on-sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift-baskets-on-sale"])
      });
    }
  